module.exports = __webpack_public_path__ + "img/bg-earning_strategy1.83dbd99c.png";